import { useFetchCaseTypes } from "@/queries/useFetchCaseTypes.ts";
import { CircularProgress, MenuItem, Paper, Typography } from "@mui/material";
import { RhfTextField } from "mui-rhf-integration";
import { useFormContext } from "react-hook-form";

const CaseTypeSelect = () => {
    const form = useFormContext();

    const { data, isError, isRefetching, isLoading } = useFetchCaseTypes(
        form.watch("idClient.idUUID"),
    );

    if (isError) {
        return (
            <Paper
                sx={{
                    p: 2,
                    borderRadius: "8px",
                }}
            >
                <Typography variant={"h5"}>Error loading case types</Typography>
            </Paper>
        );
    }

    if (isLoading || isRefetching) {
        return (
            <Paper
                sx={{
                    p: 2,
                    borderRadius: "8px",
                }}
            >
                <CircularProgress size={"12px"} />
            </Paper>
        );
    }

    return (
        <RhfTextField
            select
            control={form.control}
            name={"caseType"}
            label={"Case Type"}
            sx={{
                width: "100%",
                backgroundColor: "#fff",
            }}
        >
            {data?.data.map((caseType) => (
                <MenuItem key={`case-type-${caseType.idUUID}`} value={`${caseType.caseType}`}>
                    {caseType.caseType}
                </MenuItem>
            ))}
        </RhfTextField>
    );
};

export default CaseTypeSelect;
